import { Redirect, RouteComponentProps } from 'react-router-dom';

const dashboardCopilotDeepLinkPath = '/dashboard/me';
const copilotDeepLinkQueryParam = 'copilot';

const CopilotDeepLink = (props: RouteComponentProps) => {
  const searchParams = new URLSearchParams(props.location.search);
  searchParams.set(copilotDeepLinkQueryParam, '1');

  return <Redirect to={{ pathname: dashboardCopilotDeepLinkPath, search: searchParams.toString() }} />;
};

export default CopilotDeepLink;
